<template>
	<span>
			<label :id="identifier" href="#" tabindex="0">{{dateLabel}}</label>
			<b-popover :target="identifier"  triggers="hover" v-if="isValidIsoDate">
				<template #title ><span class="text-center">{{dateLabel}}</span></template>
				<b-table-simple hover small caption-top responsive>
					<b-tbody>
						<b-tr>
							<b-td style="font-size:12px">America/Cancun:</b-td>
							<b-td style="font-size:12px">{{dateStringUserTz}}</b-td>
						</b-tr>
						<b-tr>
							<b-td style="font-size:12px">Local Browser:</b-td>
							<b-td style="font-size:12px">{{localBrowser}}</b-td>
						</b-tr>
					</b-tbody>
				</b-table-simple>
			</b-popover>
	</span>
	
</template>

<script>
var moment = require('moment-timezone');
export default {
	name:"tag-dates",
	props: {
		date: {
			type: String,
			required: true
		}
	},
	components: {},
	data() {
		let id = this.getId();
		return {
			show:false,
			loading: false,
			identifier : id
		};
	},
	computed:{
		tzUser() {//por el momento seria estatico
			return "America/Cancun";
		},
		dateStringUserTz(){
			return moment.parseZone(this.date).tz(this.tzUser).format(
				"DD/MMMM/YYYY HH:mm:ss"
			);
		},
		localBrowser(){
			return moment.parseZone(this.date).tz(moment.tz.guess()).format(
				"DD/MMMM/YYYY HH:mm:ss"
			);
		},
		dateLabel(){
			if(this.isValidIsoDate){//Para hacer las conversiones entre timezones debe tener el formato ISO+OFFSET
				let dateStr =  moment.parseZone(this.date).tz("utc").format(
					"DD/MMMM/YYYY HH:mm:ss"
				);
				return dateStr+" UTC"
			}else{
				return this.date;
			}
		},
		isValidIsoDate(){
			return (moment(this.date,"YYYY-MM-DDTHH:mm:ssZ",true).isValid());
		}
	},
	methods: {
		getId:()=>{
			return "date-"+Math.random()
		}
	},
	mounted() {
	}
};
</script>

<style></style>
